var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useRef } from 'react';
import { motion } from "framer-motion";
import VideoSchema from './Shared/VideoSchema';
import ImageSchema from './Shared/ImageSchema';
import GetVTTTrack from './Shared/GetVTTTrack';
export default function StripContent(props) {
    var contentElementRef = useRef(null);
    var fields = props.fields, dateAndTimeRead = props.dateAndTimeRead, children = props.children, isFlyoverSite = props.isFlyoverSite;
    var TitleTag = (fields.titleTag || 'h1');
    var PreTitleTag = (fields.preTitleTag || 'h4');
    var _a = useState(fields.contentTitle || ""), content = _a[0], setContent = _a[1];
    function removeScriptTags(inputString) {
        if (!inputString)
            return inputString;
        // Use a regular expression to match and remove script tags
        var withoutScripts = inputString.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
        return withoutScripts;
    }
    function loadScripts(array, callback) {
        var loader = function (scriptSrc, handler) {
            if (scriptSrc.dataset["executelocal"] == "1") {
                if ((scriptSrc.textContent || "").length) {
                    try {
                        // console.log("execute script:", scriptSrc.textContent);
                        eval.call(window, scriptSrc.textContent); // TODO: check the script order exectution
                    }
                    catch (e) {
                        console.log("dynamic script code execution fail", e);
                    }
                }
                handler();
                return;
            }
            //var script = document.createElement("script");
            //script.src = scriptSrc.src;
            //script.async = false;
            scriptSrc.onload = (function () {
                scriptSrc.onload = null;
                handler();
            }).bind(this);
            if (!contentElementRef.current) {
                console.warn("Add dynamic scripts failed - Target content element reference is null");
            }
            contentElementRef.current && contentElementRef.current.appendChild(scriptSrc);
        };
        (function run() {
            if (array.length > 0) {
                loader(array.shift(), run);
            }
            else {
                callback && callback();
            }
        })();
    }
    // let [srcScripts, setSrcScripts] = useState([]);
    //let content = fields.contentTitle;
    //let srcScripts = [];
    //var parseContent = new DOMParser().parseFromString(fields.contentTitle, 'text/html');
    //var scripts = parseContent.getElementsByTagName('script');
    //if (scripts && scripts.length > 0) {
    //    for (var i = 0; i < scripts.length; i++) {
    //        content = content.split(scripts[i].outerHTML.split(`async=""`).join("async")).join("");
    //        srcScripts.push(scripts[i].src)
    //    }
    //}
    var getTextAlignment = function (textAlignment) {
        if (textAlignment == "left") {
            return "start";
        }
        else if (textAlignment == "right") {
            return "end";
        }
        return "center";
    };
    useEffect(function () {
        var currentContentElement = contentElementRef.current;
        // console.log("strip content: ", currentContentElement);
        var srcScripts = [];
        if (fields.contentTitle && fields.contentTitle.indexOf("script") >= 0) {
            var content_1 = fields.contentTitle;
            var parseContent = new DOMParser().parseFromString(fields.contentTitle, 'text/html');
            var scripts = parseContent.getElementsByTagName('script');
            if (scripts && scripts.length > 0) {
                for (var i = 0; i < scripts.length; i++) {
                    // content = content.split(scripts[i].outerHTML.split(`async=""`).join("async")).join("");
                    srcScripts.push(scripts[i]);
                }
            }
            //setSrcScripts(srcScript);
            var contentWithoutScripts = removeScriptTags(fields.contentTitle);
            setContent(contentWithoutScripts);
        }
        if (srcScripts.length && currentContentElement) {
            var scriptElements_1 = [];
            var scriptsForExecution_1 = [];
            srcScripts.forEach(function (scriptSrc) {
                var script = document.createElement('script');
                script.type = scriptSrc.type;
                script.src = scriptSrc.src;
                script.async = false;
                if (!scriptSrc.src) {
                    script.dataset["executelocal"] = "1";
                    script.textContent = scriptSrc.textContent;
                    scriptsForExecution_1.push(script);
                }
                else {
                    scriptElements_1.push(script);
                    scriptsForExecution_1.push(script);
                }
            });
            loadScripts(scriptsForExecution_1, function () {
                // fix resize issues
                executeResizeRepeatedly(800, 15000);
                //
            });
            return function () {
                scriptElements_1 && scriptElements_1.forEach(function (scriptEl) {
                    try {
                        currentContentElement && currentContentElement.removeChild(scriptEl);
                    }
                    catch (e) {
                        console.log(e);
                    }
                });
            };
        }
    }, []);
    function executeResizeRepeatedly(interval, maxDuration) {
        var elapsed = 0;
        // Function to be executed at each interval
        function task() {
            // console.log("Task executed");
            window.dispatchEvent(new Event('resize'));
            // Increment elapsed time
            elapsed += interval;
        }
        // Start the interval
        var intervalId = setInterval(task, interval);
        // Stop the interval after maxDuration
        setTimeout(function () {
            clearInterval(intervalId);
            // console.log("Interval stopped");
        }, maxDuration);
    }
    useEffect(function () {
        if (fields.contentTitle && fields.contentTitle.indexOf("script") >= 0) {
            var element_1 = document.getElementById('form-subscribe');
            var search = window.location.search;
            var params = new URLSearchParams(search);
            var email_1 = params.get('email');
            if ((email_1 || "").length) {
                setTimeout(function () {
                    if (element_1 && email_1 && email_1.length > 0) {
                        var parent_1 = findAncestor(element_1, "sky23-content");
                        parent_1.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 1000);
            }
        }
    }, [content]);
    function findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls))
            ;
        return el;
    }
    return (
    //< !--BEGIN: GENERAL CONTENT-- >
    React.createElement(motion.div, __assign({ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-20%" }, className: "strip sky23-content strip-spacing position-relative component-wrapper text-"
            + (fields.textColour ? (isFlyoverSite ? ("color-" + fields.textColour) : fields.textColour) : "primary")
            + ((fields.background) ? (" bg-" + fields.background) : "")
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + ((fields.contentWidth) ? (" content-width-" + fields.contentWidth) : "")
            + ((fields.videoURL || fields.backgroundImage) ? "" : " no-media")
            + (isFlyoverSite ? "" : " border-radius box-shadow-lg container-fluid") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: (isFlyoverSite ? "container-fluid" : "") + (fields.contentWidth == "full" ? " mw-100 px-0" : "") },
            React.createElement("div", { className: "row h-100 justify-content-center " + "text-" + getTextAlignment(fields.textAlignment) },
                React.createElement("div", { className: "col" + (isFlyoverSite ? "" : " content-width-wrapper px-5"), itemScope: true, itemType: "https://schema.org/Thing" },
                    dateAndTimeRead && React.createElement("div", { className: "row justify-content-center", itemProp: "subjectOf", itemScope: true, itemType: "https://schema.org/Article" },
                        React.createElement("div", { className: "article-date-time" },
                            React.createElement("span", { itemProp: "dateCreated" }, dateAndTimeRead.date),
                            React.createElement("span", null, "\u00A0\u2022\u00A0"),
                            React.createElement("span", { itemProp: "timeRequired" }, dateAndTimeRead.timeRead)),
                        React.createElement("meta", { itemProp: "author", content: "Sky Lagoon" })) || null,
                    React.createElement("div", { className: "row flex-column" },
                        React.createElement("div", { className: "col col-auto", ref: contentElementRef },
                            fields.icon && React.createElement("img", { src: fields.icon, className: "content-icon mb-3", title: fields.displayTitle ? fields.displayTitle : "Image Title", alt: fields.icon_description ? fields.icon_description : "", width: "66", itemProp: "image" }) || null,
                            fields.preTitle && React.createElement(PreTitleTag, { className: "".concat(fields.preTitleStyle, " bg-").concat((fields.preTitleBackgroundColour ? fields.preTitleBackgroundColour : ""), " text-").concat((fields.preTitleTextColour ? fields.preTitleTextColour : ""), " text-uppercase") }, fields.preTitle) || null,
                            fields.displayTitle &&
                                React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null,
                            !fields.hideArrow && React.createElement("div", { className: "button-col" },
                                React.createElement("a", { href: fields.link ? fields.link : "#", className: "btn btn-icon mb-3 arrow arrow-" + (fields.directionArrow ? fields.directionArrow : "right"), role: "button", "aria-label": fields.linkTitle ? fields.linkTitle : "Link Title", itemProp: "url" }, fields.linkTitle &&
                                    React.createElement("span", null, fields.linkTitle))) || null,
                            content && React.createElement("div", { className: "strip-content", dangerouslySetInnerHTML: { __html: content }, itemProp: "description", id: fields.contentTitle && fields.contentTitle.indexOf("script") >= 0 ? "form-subscribe" : "" }) || null))),
                (fields.videoURL || fields.backgroundImage || fields.mobileVideoURL || fields.mobileBackgroundImage) &&
                    React.createElement("div", { className: "media-container" },
                        fields.videoURL && React.createElement(React.Fragment, null,
                            VideoSchema(fields.videoURL, fields.videoPoster, fields.displayTitle, fields.contentTitle),
                            React.createElement("video", { className: "media border-radius", poster: fields.videoPoster ? fields.videoPoster : "", role: "img", "aria-label": "Sky Lagoon", controls: false, playsInline: true, autoPlay: true, muted: true, loop: true, style: { pointerEvents: 'none' } },
                                React.createElement("source", { src: fields.videoURL, type: "video/mp4" }),
                                children && children.length > 0 && children.map(function (item, i) {
                                    return GetVTTTrack(item, i);
                                }),
                                React.createElement("meta", { itemProp: "description", content: fields.videoURL_description ? fields.videoURL_description : "" }))) || null,
                        fields.mobileVideoURL && React.createElement(React.Fragment, null,
                            VideoSchema(fields.mobileVideoURL, fields.videoPoster, fields.displayTitle, fields.contentTitle),
                            React.createElement("video", { className: "media-mobile border-radius", poster: fields.videoPoster ? fields.videoPoster : "", role: "img", "aria-label": "Sky Lagoon", controls: false, playsInline: true, autoPlay: true, muted: true, loop: true, style: { pointerEvents: 'none' } },
                                React.createElement("source", { src: fields.mobileVideoURL, type: "video/mp4" }),
                                children && children.length > 0 && children.map(function (item, j) {
                                    return GetVTTTrack(item, j);
                                }),
                                React.createElement("meta", { itemProp: "description", content: fields.mobileVideoURL_description ? fields.mobileVideoURL_description : "" }))) || null,
                        fields.backgroundImage && React.createElement(React.Fragment, null,
                            ImageSchema(fields.backgroundImage, fields.displayTitle, fields.contentTitle),
                            React.createElement("img", { src: fields.backgroundImage, className: "img-fluid media w-100 border-radius", title: fields.displayTitle ? fields.displayTitle : "Image Title", alt: fields.backgroundImage_description ? fields.backgroundImage_description : "" })) || null,
                        fields.mobileBackgroundImage && React.createElement(React.Fragment, null,
                            ImageSchema(fields.mobileBackgroundImage, fields.displayTitle, fields.contentTitle),
                            React.createElement("img", { src: fields.mobileBackgroundImage, className: "img-fluid media-mobile w-100 border-radius", title: fields.displayTitle ? fields.displayTitle : "Image Title", alt: fields.mobileBackgroundImage_description ? fields.mobileBackgroundImage_description : "" })) || null)))));
}
